export default __webpack_public_path__ + "fonts/import-properties-img.svg";